import { IShoppingValuesSection } from '@features/productPreview/typescript';
import { WindowType } from '@typescript/index';
import styles from '@features/productPreview/sections/UniversalShoppingValues/ShoppingValues.styles';
import ErrorBoundary from '@components/errors/ErrorBoundary';
import UniversalShoppingValues from './components/IconWithText/UniversalShoppingValues';
type PropsType = {
  section: IShoppingValuesSection;
  windowType: WindowType;
};
const ShoppingValuesSection = ({
  section,
  windowType
}: PropsType) => {
  if (section.items.length === 0) return null;
  const notEmptyItems = section.items.filter(singleItem => singleItem.title.length > 0 && singleItem.content.length > 0);
  if (notEmptyItems.length === 0) return null;
  const isNarrowerThanTablet: boolean = windowType === WindowType.mobile;
  const mappedItems = section.items.map(el => ({
    ...el,
    itemId: el.descriptionCode
  }));
  return <ErrorBoundary>
      <section sx={styles.sectionContainer(mappedItems.length)}>
        <UniversalShoppingValues data={mappedItems} isNarrowerThanTablet={isNarrowerThanTablet} />
      </section>
    </ErrorBoundary>;
};
export default ShoppingValuesSection;